<template>
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_404_254)">
            <path d="M4.66602 4.66666L11.3327 11.3333M4.66602 11.3333L11.3327 4.66666" stroke="currentColor"
                stroke-linecap="round" stroke-linejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_404_254">
                <rect width="16" height="16" fill="currentColor" />
            </clipPath>
        </defs>
    </svg>
</template>